import { render, staticRenderFns } from "./FavoritesCard.vue?vue&type=template&id=6a145acf&"
import script from "./FavoritesCard.vue?vue&type=script&lang=js&"
export * from "./FavoritesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a145acf')) {
      api.createRecord('6a145acf', component.options)
    } else {
      api.reload('6a145acf', component.options)
    }
    module.hot.accept("./FavoritesCard.vue?vue&type=template&id=6a145acf&", function () {
      api.rerender('6a145acf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/favorites/FavoritesCard.vue"
export default component.exports